import React, { useState } from "react";

import { Plus } from "icons";
import { isEmpty } from "ramda";

import {
  Button,
  Table,
  Typography,
  Pagination,
} from "clearsense-ui/components";
import ExploreContainer from "components/Common/ExploreContainer";
import FilterHeader from "components/Common/FilterHeader";
import NoData from "components/Common/NoData";
import PermissibleWrapper from "components/Common/PermissibleWrapper";
import { useUserState } from "contexts/user";
import { useColumnHeaderSelector } from "hooks/useColumnHeaderSelector";
import { getPermissions } from "utils/roleBasedAccess";

import AssociateSteward from "./AssociateSteward";

import { STEWARDS_COLUMNS, STEWARDS_DATA } from "../../constants/explorePage";
import DomainsSummaryCard from "../DomainsSummaryCard";

const People = ({ features, domain }) => {
  const user = useUserState();
  const userPermissions = getPermissions(features, user?.role);

  const columnHeaderSelector = useColumnHeaderSelector(STEWARDS_COLUMNS);

  const [isPaneOpen, setIsPaneOpen] = useState(false);

  return (
    <ExploreContainer>
      <div className="flex justify-between">
        <Typography style="h3" type="semibold">
          People in {domain?.name}(5)
        </Typography>
        <Typography style="h3" type="semibold">
          Summary
        </Typography>
        <PermissibleWrapper
          currentPermissions={userPermissions}
          acceptablePermissions="associate"
        >
          <Button
            label="Associate People"
            icon={Plus}
            onClick={() => ""}
            data-cy="associate-prople-button"
          />
        </PermissibleWrapper>
      </div>
      <DomainsSummaryCard domain={domain} />
      <FilterHeader
        filterParams={{ setSearch: () => {} }}
        entity="Steward"
        columnHeaderSelector={columnHeaderSelector}
        count={5}
        userPermissions={userPermissions}
      />
      {!isEmpty(STEWARDS_DATA) ? (
        <div className="mt-8">
          <Table
            rowData={STEWARDS_DATA}
            columnData={columnHeaderSelector.columns.selected}
          />
          <Pagination
            currentPage={1}
            pageSize={7}
            showResultsPerPage
            totalRecordsCount={100}
          />
        </div>
      ) : (
        <NoData
          actionLabel="Associate Steward"
          entity="stewards"
          onAction={() => setIsPaneOpen(true)}
        />
      )}
      <AssociateSteward isPaneOpen={isPaneOpen} setIsPaneOpen={setIsPaneOpen} />
    </ExploreContainer>
  );
};

export default People;
